import {
  HomePageCompanyLogo
} from "@backstage/plugin-home";
import ImageRender from "./ImageRender";
import Grid from "@material-ui/core/Grid";
import Logo from "./images/leo-banner.png";
import React from "react";
import {Link} from "@material-ui/core";

export const LeoVegasBanner = () => {
  return(
    <div style={{backgroundColor: "#f38925", background: "radial-gradient(#fffec0, #f38925, #CC5500)", marginBottom: "1rem", padding: "1rem"}}>
      <Grid container justifyContent="center" direction="column" alignItems="center">
        <HomePageCompanyLogo logo={<ImageRender image={Logo} alt="Leovegas Logo" width="350" height="350" />} />
        <h1><Link href="/docs/default/component/leo-backstage" color="textPrimary" underline="always">What is Backstage?</Link></h1>
      </Grid>
    </div>
  );
}